<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-安全投入-添加
    -->
    <el-dialog
    title="添加安全投入"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

      <!-- 预算维度 -->
      <el-form-item label="预算维度" prop="budget_dimension">
        <el-radio-group v-model="form.budget_dimension">
          <el-radio label="年度预算">年度预算</el-radio>
          <el-radio label="月度预算">月度预算</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 上期营收 -->
      <el-form-item label="上期营收" prop="last_period_revenue">
        <div class="input-with-unit">
          <el-input v-model="form.last_period_revenue" placeholder="请输入上期营收" class="max-w460" type="number" step="0.01"></el-input>
          <span class="unit">万元</span>
        </div>
      </el-form-item>

      <!-- 上期营收凭证 -->
      <el-form-item label="上期营收凭证" prop="last_period_revenue_voucher">
        <div class="draggable-list">
          <div v-for="(item, index) in form.last_period_revenue_voucher" :key="index" class="item">
            <img v-img-url="item" alt="file_path" />
            <span class="delete-btn" @click="deleteVoucher(index)">×</span>
          </div>
          <div class="item img-select" @click="openProductUpload('voucher')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
        <span class="tip">*只能上传png,jpg,jpeg文件,最多8个,且不超过5MB</span>
      </el-form-item>

      <!-- 提取比例 -->
      <el-form-item label="提取比例" prop="extraction_ratio">
        <div class="input-with-unit">
          <el-input v-model="form.extraction_ratio" placeholder="请输入提取比例" class="max-w460" type="number" step="0.01"></el-input>
          <span class="unit">%</span>
        </div>
        <span class="tip">*根据企业经营的主营业务领域自动获取,可根据企业实际情况调整比例</span>
      </el-form-item>

      <!-- 上期结余 -->
      <el-form-item label="上期结余" prop="last_period_balance">
        <div class="input-with-unit">
          <el-input v-model="form.last_period_balance" placeholder="请输入上期结余" class="max-w460" type="number" step="0.01"></el-input>
          <span class="unit">万元</span>
        </div>
      </el-form-item>

      <!-- 预算总额 -->
      <el-form-item label="预算总额" prop="budget_total">
        <div class="input-with-unit">
          <el-input v-model="form.budget_total" placeholder="请输入预算总额" class="max-w460" type="number" step="0.01"></el-input>
          <span class="unit">万元</span>
        </div>
      </el-form-item>

      <!-- 编制日期 -->
      <el-form-item label="编制日期" prop="compile_date">
        <el-date-picker v-model="form.compile_date" type="date" placeholder="请选择编制日期" class="max-w460"></el-date-picker>
      </el-form-item>

      <!-- 编制人 -->
      <el-form-item label="编制人" prop="compiler">
        <el-select v-model="form.compiler" placeholder="请选择" class="max-w460" filterable>
          <el-option v-for="item in employeeList" :key="item.id" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </el-form-item>

      <!-- 审核人 -->
      <el-form-item label="审核人" prop="reviewer">
        <div class="select-with-tip">
          <el-select v-model="form.reviewer" placeholder="请选择" class="max-w460" filterable>
            <el-option v-for="item in employeeList" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
          <span class="tip">例如：分管安全副总经理</span>
        </div>
      </el-form-item>

      <!-- 审批人 -->
      <el-form-item label="审批人" prop="approver">
        <div class="select-with-tip">
          <el-select v-model="form.approver" placeholder="请选择" class="max-w460" filterable>
            <el-option v-for="item in employeeList" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
          <span class="tip">例如：总经理</span>
        </div>
      </el-form-item>

      <el-form-item label="排序" prop="sort"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--业务附件上传组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
 </div>
</el-dialog>
  
</template>

<script>
import Ma_safety_investmentApi from '@/api/ma_safety_investment.js';
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,

     draggable,
     Uediter
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:[],
        // categorya:{},
        sort:50,
        intro:"",
        bannar:[],
        budget_dimension: '年度预算',
        last_period_revenue: '',
        last_period_revenue_voucher: [],
        extraction_ratio: 1.0,
        last_period_balance: '',
        budget_total: '',
        compile_date: '',
        compiler: '',
        reviewer: '',
        approver: ''
      },
      loading: false,
      /*员工列表数据*/
      employeeList: [],
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入安全投入名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    /*加载员工列表数据*/
    this.loadEmployees();
  },
  props: ["open_add"],
  methods: {

    chooseCategory(){
      this.iscategorya = true;
    },

    /*加载员工列表数据*/
    loadEmployees() {
      let self = this;
      AfuncApi.call({ model: 'ma_yg', action: 'getList' }, true)
          .then(data => {
            if (data.code == 1) {
              self.employeeList = data.data.list.data;
            }
          })
          .catch(error => {
          });
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      // form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Ma_safety_investmentApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else if(this.code == 'bannar'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }else if(this.code == 'voucher'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.last_period_revenue_voucher.concat(e.map(item => item.file_path));
        this.$set(this.form, "last_period_revenue_voucher", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除业务附件*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

    /*删除上期营收凭证*/
    deleteVoucher(index) {
      this.form.last_period_revenue_voucher.splice(index, 1);
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

/* 带单位的输入框 */
.input-with-unit {
  position: relative;
  display: inline-block;
  width: 100%;
}

.input-with-unit .unit {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #909399;
}

/* 带提示的选择框 */
.select-with-tip {
  position: relative;
}

.select-with-tip .tip {
  display: block;
  margin-top: 5px;
  color: #909399;
  font-size: 12px;
}

/* 提示文本 */
.tip {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 5px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_safety_investment/index/part/add.vue